<template>
  <div class="footer">
    <van-tabbar v-model="active" route active-color="#FC6E09">
      <!-- <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/productList/pro" icon="goods-collect-o">产品库</van-tabbar-item>-->
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <template #icon="props">
          <!-- <van-image :src="props.active ? icon.active : icon.inactive" /> -->
          <svg-icon :icon-class="props.active ? icon.active : icon.inactive"></svg-icon>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/productList">
        <span>产品库</span>
        <template #icon="props">
          <svg-icon :icon-class="props.active ? icon.active1 : icon.inactive1"></svg-icon>
          <!-- <van-image :src="props.active ? icon.active1 : icon.inactive1" /> -->
        </template>
      </van-tabbar-item>
<!--      <van-tabbar-item replace to="/myTeam">-->
<!--        <span>团队</span>-->
<!--        <template #icon="props">-->
<!--          &lt;!&ndash; <van-image :src="props.active ? icon.active2 : icon.inactive2" /> &ndash;&gt;-->
<!--          <svg-icon :icon-class="props.active ? icon.active2 : icon.inactive2"></svg-icon>-->
<!--        </template>-->
<!--      </van-tabbar-item>-->
      <van-tabbar-item replace to="/mine">
        <span>我的</span>
        <template #icon="props">
          <!-- <van-image :src="props.active ? icon.active3 : icon.inactive3" /> -->
          <svg-icon :icon-class="props.active ? icon.active3 : icon.inactive3"></svg-icon>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      icon: {
        active:'foot_home1',
        inactive: 'foot_home',
        active1: 'foot_product',
        inactive1:'foot_product1',
        active2: 'foot_team1',
        inactive2: 'foot_team',
        active3: 'foot_wode1',
        inactive3: 'foot_wode'
      }
    };
  },
};
</script>
<style lang="less" scoped>
.footer {
  /* width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  border: 1px solid; */
  // padding-bottom:constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  // padding-bottom:env(safe-area-inset-bottom);/* 兼容 iOS >= 11.2 */
  .svg-icon{
    width: 20px;
    height: 20px;
  }
  .van-tabbar {
    height: 49px;
    .van-image {
      width: 15px;
      height: 15px;
      /deep/ img {
        width: 100% !important;
        height: 100%;
      }
    }
  }
  .van-tabbar-item {
    font-size: 10px;
  }
  .van-tabbar-item--active {
    color: #fc6e09;
  }
}
</style>
